export default "<div class=\"spinner-wrapper\">\n    <img src=\"../../../assets/img/Eclipse-1s-200px.gif\" style=\"margin-left: 9%;\">\n</div>\n\n\n\n\n";